<!-- Ported from the Polaris kit: src/product/components/InboxCard.vue.
     Classes translated to Tailwind 3 by rebranding_frontend/port-kit-component.mjs;
     strings moved to i18n by hand. Change the design in the kit first. -->
<script setup>
// A channel the agent answers on: its mark, its name and the number or address after it. The one thing to do is to disconnect it.
import { useI18n } from 'vue-i18n';
import { Unlink16 } from '@carbon/icons-vue';
import {
  Item,
  ItemActions,
  ItemContent,
  ItemMedia,
  ItemTitle,
} from '../ui/item';
import ChannelIcon from 'next/icon/ChannelIcon.vue';
import RowMenu from './RowMenu.vue';

defineProps({
  name: { type: String, required: true },
  // o channel_type do app, por exemplo 'Channel::Whatsapp'
  channel: { type: String, required: true },
  identifier: { type: String, default: '' }, // a phone number or an address
});

const emit = defineEmits(['action']);

const { t } = useI18n();

const items = [
  {
    label: t('POLARIS.CARDS.DISCONNECT'),
    value: 'disconnect',
    icon: Unlink16,
    destructive: true,
  },
];
</script>

<template>
  <Item variant="outline" size="sm" class="min-w-0 flex-nowrap" data-inbox-card>
    <ItemMedia>
      <ChannelIcon
        :inbox="{ channel_type: channel }"
        use-brand-icon
        class="size-4"
      />
    </ItemMedia>
    <ItemContent class="min-w-0">
      <ItemTitle class="max-w-full truncate">
        {{ identifier ? `${name} (${identifier})` : name }}
      </ItemTitle>
    </ItemContent>
    <ItemActions>
      <RowMenu
        :label="`Actions for ${name}`"
        :items="items"
        @action="value => emit('action', { action: value })"
      />
    </ItemActions>
  </Item>
</template>
